const e=async(e,t,n)=>{await e.post(`/auth/mfa/totp/verify`,{userCode:t,session:n})};export{e as verifyTotpSetup};
//# sourceMappingURL=verify-totp-setup.mjs.map